import { createSlice } from "@reduxjs/toolkit";

const defaultValue = {
  showLoader: false,
  loaderMessage: "",
  showBackDrop: false,
};

export const loaderSlice = createSlice({
  name: "loader",
  initialState: defaultValue,
  reducers: {
    showLoader: (state, action) => {
      let newValueState = { ...state };
      const payload = action.payload;
      newValueState.loaderMessage = payload.loaderMessage ?? "";
      newValueState.showLoader = payload.showLoader ?? false;
      newValueState.showBackDrop = payload.showBackDrop ?? false;
      return newValueState;
    },
    hideLoader: (state) => {
      let newValueState = { ...state };
      newValueState.loaderMessage = "";
      newValueState.showLoader = false;
      return newValueState;
    },
  },
});
export const { showLoader, hideLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
